import React from 'react';
import { IconTitle, IconTitleProps } from '../IconTitle';

export type SectionTitleProps = IconTitleProps;

export const SectionTitle: React.FC<SectionTitleProps> = (props) => {
  return <IconTitle {...props} variant="title" />;
};
